// extracted by mini-css-extract-plugin
export default {"demoModeFullScreen":"styles_demoModeFullScreen__2Sgnd","returnLink":"styles_returnLink__wqLTy","initialDemoModeBackground":"styles_initialDemoModeBackground__3aKCT"};